import { Injectable } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormControl, UntypedFormArray, FormArray, FormGroup, AbstractControl, FormControl } from '@angular/forms';
import { DhlFormTemplate } from '../models/dhl-form-template';
import { APP_Constants } from 'src/app/app.constant';
import { Subject } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';

type FormTemplate = DhlFormTemplate;

@Injectable({ providedIn: 'root' })
export class FormService {

  constructor(private appService: AppService, private router: Router) { }
  quoteType:string;
  private catalog;
  private _commonSubject = new Subject<any>();

  setCatalogData(data) {
    this.catalog = data;
  }
  //the belw  functions is to notify when the standard/schedule toggle changes to show/hide enable/oparable toggle hints
  private quotReqToggleButtonSubject = new Subject<string>();
  public quotToggleValue$ = this.quotReqToggleButtonSubject.asObservable();
  public quotReqToggleSet(value: string): void {
    this.quotReqToggleButtonSubject.next(value);
  }
  /////
  //the belw  functions is to notify when the Include trade-in vehicle pickup toggle changes to show/hide enable/oparable toggle hints
  private tradeinMainToggleButtonSubject = new Subject<string>();
  public tradeinMainToggleValue= this.tradeinMainToggleButtonSubject.asObservable();
  public tradeinMainToggleSet(value: any): void {
    this.tradeinMainToggleButtonSubject.next(value);
  }
  /////

  getDateFormat(date) {
    return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
  }
  createForm(formTemplate): any {
    let newGroup = {};
    let controlGroup = {};
    let fieldGroup = {};
    let groupArray: any = [];
    let fieldArray: any = [];
    let dGroup = {};
    let eGroup = {};
    let eArray = [];

    let sectionGroup = {};
    let sectionArray = [];

    let mainForm = {};

    let subForms = [];
    let grp = {};
    if (formTemplate.sections) {
      let subform = false;
      formTemplate.sections.forEach(section => {
        sectionGroup = this.createForm(section);
        grp[section.name] = sectionGroup;
        subForms.push(grp);
        sectionArray.push(sectionGroup);
        sectionGroup = {}
        mainForm[section.name] = new UntypedFormArray(sectionArray);
        sectionArray = []
        subform = section['subForm'] ? true : false;
        // mainForm[data.name] = new FormArray(groupArray);

        // mainForm[section.name] = new FormGroup(arr);
      });
      // mainForm[formTemplate.name] = new FormGroup(mainForm)
      // console.log(new FormGroup(mainForm));
      if (subform) {
        return { subform: true, form: subForms };
      } else {
        return new UntypedFormGroup(mainForm);
      }
    }
    // else if(formTemplate.subgroups){
    //   let subgroup = {};
    //   formTemplate.subgroups.forEach((grp,index)=>{
    //     return this.createForm(grp);
    //   })
    //   // return subgroup;
    // }

    else if (formTemplate.groups) {
      formTemplate.groups.forEach(group => {
        let menuPages = JSON.parse(localStorage.getItem('menuPages'));
        if ((group.roleAccess && menuPages.includes(group.roleAccess)) || !group.roleAccess) {
          group.controls.forEach(data => {
            if (data.component == 'DATEPICKER') {
              newGroup[data.name] = data.required === true ? new UntypedFormControl(Object.keys(data.defaultValue).length === 0 ? '' : new Date(data.defaultValue.displayValue), Validators.required) : new UntypedFormControl(Object.keys(data.defaultValue).length === 0 ? '' : new Date(data.defaultValue.displayValue));
            }
            else if (Array.isArray(data.controls)) {

              data.controls.forEach(field => {

                if (Array.isArray(field.controls)) {
                  field.controls.forEach(d => {
                    if (Array.isArray(d.controls)) {
                      d.controls.forEach(e => {
                        if (Array.isArray(e.controls)) {
                          e.controls.forEach(f => {
                            eGroup[f.name] = f.required === true ? new UntypedFormControl
                              (Object.keys(f.defaultValue).length === 0 ? '' : f.defaultValue, Validators.required) : new UntypedFormControl(Object.keys(f.defaultValue).length === 0 ? '' : f.defaultValue);
                          })

                          eArray.push(new UntypedFormGroup(eGroup));
                          eGroup = {};

                          fieldGroup[e.name] = new UntypedFormArray(eArray);
                          eArray = [];

                          e.validation.forEach(check => {
                            if ((check === 'ZeroOrMoreLines')) {
                              dGroup[e.name] = new UntypedFormArray([]);
                            }
                          });
                          fieldArray.push(new UntypedFormGroup(fieldGroup));
                          fieldGroup = {};

                        } else {
                          dGroup[e.name] = e.required === true ? new UntypedFormControl
                            (Object.keys(e.defaultValue).length === 0 ? '' : e.defaultValue, Validators.required) : new UntypedFormControl(Object.keys(e.defaultValue).length === 0 ? '' : e.defaultValue);

                          //eArray.push(new FormGroup(eGroup));
                          // eGroup = {}; // check with Rahul, if this comment is correct or not
                        }
                        // eArray.push(eGroup);
                        //fieldGroup[d.name] = new FormArray(eArray);
                        //eArray = [];
                      })
                      if (!fieldArray.length) {
                        eArray.push(new UntypedFormGroup(dGroup));
                        dGroup = {};
                        fieldGroup[d.name] = new UntypedFormArray(eArray);
                        eArray = [];
                      }

                    } else {
                      fieldGroup[d.name] = d.required === true ? new UntypedFormControl
                        (Object.keys(d.defaultValue).length === 0 ? '' : d.defaultValue, Validators.required) : new UntypedFormControl(Object.keys(d.defaultValue).length === 0 ? '' : d.defaultValue);
                    }
                  })
                  if (!fieldArray.length) {
                    fieldArray.push(new UntypedFormGroup(fieldGroup));
                    fieldGroup = {};
                  }
                  controlGroup[field.name] = new UntypedFormArray(fieldArray);
                  fieldArray = [];

                  field.validation.forEach(check => {
                    if ((check === 'ZeroOrMoreLines')) {
                      controlGroup[field.name] = new UntypedFormArray([]);
                    }
                  })
                  groupArray.push(new UntypedFormGroup(controlGroup));
                  controlGroup = {};

                } else {
                  if (field.component === 'DATEPICKER')
                    controlGroup[field.name] = field.required === true ? new UntypedFormControl
                      (Object.keys(field.defaultValue).length === 0 ? '' : field.defaultValue.value, Validators.required) : new UntypedFormControl(Object.keys(field.defaultValue).length === 0 ? '' : field.defaultValue.value);
                  else
                    controlGroup[field.name] = field.required === true ? new UntypedFormControl
                      (Object.keys(field.defaultValue).length === 0 ? '' : field.defaultValue, Validators.required) : new UntypedFormControl(Object.keys(field.defaultValue).length === 0 ? '' : field.defaultValue);
                }
              })
              if (groupArray.length) {
                newGroup[data.name] = new UntypedFormArray(groupArray);
                groupArray = [];
              } else {
                groupArray.push(new UntypedFormGroup(controlGroup));
                controlGroup = {};
                newGroup[data.name] = new UntypedFormArray(groupArray);
                groupArray = [];
              }

              data.validation.forEach(check => {
                if ((check === 'ZeroOrMoreLines')) {
                  newGroup[data.name] = new UntypedFormArray([]);
                }
              })

            } else {
              newGroup[data.name] = data.required === true ? new UntypedFormControl(Object.keys(data.defaultValue).length === 0 ? '' : data.defaultValue, Validators.required) : new UntypedFormControl(Object.keys(data.defaultValue).length === 0 ? '' : data.defaultValue);
            }
          })
        }
      });
    } else {
      formTemplate && formTemplate.controls && formTemplate.controls.forEach(data => {
        if (data.component == 'DATEPICKER') {
          newGroup[data.name] = data.required === true ? new UntypedFormControl(Object.keys(data.defaultValue).length === 0 ? '' : new Date(data.defaultValue.displayValue), Validators.required) : new UntypedFormControl(Object.keys(data.defaultValue).length === 0 ? '' : new Date(data.defaultValue.displayValue));
        } else if (Array.isArray(data.controls)) {
          data.controls.forEach(field => {
            if (field.component == 'DATEPICKER') {
              controlGroup[field.name] = field.required === true ? new UntypedFormControl
                (Object.keys(field.defaultValue).length === 0 ? '' : field.defaultValue.displayValue, Validators.required) : new UntypedFormControl(Object.keys(field.defaultValue).length === 0 ? '' : field.defaultValue.displayValue);
            } else {
              if (Array.isArray(field.controls)) {
                field.controls.forEach(e => {
                  fieldGroup[e.name] = e.required === true ? new UntypedFormControl
                    (this.getFormControlDefaultValue(e), Validators.required) : new UntypedFormControl(this.getFormControlDefaultValue(e));
                })

                if (!fieldArray.length) {
                  fieldArray.push(new UntypedFormGroup(fieldGroup));
                  fieldGroup = {};
                }
                controlGroup[field.name] = new UntypedFormArray(fieldArray);
                fieldArray = [];

                field.validation.forEach(check => {
                  if ((check === 'ZeroOrMoreLines')) {
                    controlGroup[field.name] = new UntypedFormArray([]);
                  }
                })
                groupArray.push(new UntypedFormGroup(controlGroup));
                controlGroup = {};

              } else {
                controlGroup[field.name] = field.required === true ? new UntypedFormControl
                  (Object.keys(field.defaultValue).length === 0 ? '' : field.defaultValue, Validators.required) : new UntypedFormControl(Object.keys(field.defaultValue).length === 0 ? '' : field.defaultValue);
              }
            }
          })
          if (groupArray.length) {
            newGroup[data.name] = new UntypedFormArray(groupArray);
            groupArray = [];
          } else {
            groupArray.push(new UntypedFormGroup(controlGroup));
            controlGroup = {};
            newGroup[data.name] = new UntypedFormArray(groupArray);
            groupArray = [];
          }
        } else {
          newGroup[data.name] = data.required === true ? new UntypedFormControl(Object.keys(data.defaultValue).length === 0 ? '' : data.defaultValue, Validators.required) : new UntypedFormControl(Object.keys(data.defaultValue).length === 0 ? '' : data.defaultValue);
        }
      });
    }
    // console.log(new FormGroup(newGroup));
    return new UntypedFormGroup(newGroup);
  }

  getFormControlDefaultValue(control) {
    if (Object.keys(control.defaultValue).length === 0) { return ''; }
    if ('dataType' in control.defaultValue && control.defaultValue.dataType === 'STRING') {
      return control.defaultValue.value;
    }else if ('dataType' in control.defaultValue && control.defaultValue.dataType === 'INTEGER') {
      return control.defaultValue.value;
    } else {
      return control.defaultValue;
    }
  }

  simpleFormCreation(json) {
    
    // implment error pattern form template validation attribute
    
    if (json.sections) {
      let sectionForm = {};
      let mainForm = {};
      let sectionArray = [];
      json.sections.forEach(section => {
        sectionForm = this.simpleFormCreation(section);
        sectionArray.push(sectionForm);
        sectionForm = {};
        mainForm[section.name] = new UntypedFormArray(sectionArray);
        sectionArray = [];
      })
      return new UntypedFormGroup(mainForm);
    } else if (json.groups) {
      let groupForm = {};
      json.groups.forEach(group => {
        let menuPages = JSON.parse(localStorage.getItem('menuPages'));
        if ((group.roleAccess && menuPages.includes(group.roleAccess)) || !group.roleAccess) {
          group.controls.forEach(control => {
            groupForm[control.name] = this.createFormControl(control);
          });
        }
      });
      return new UntypedFormGroup(groupForm);
    }
    else {
      let controlForm;
      controlForm = this.createFormControl(json);
      return controlForm;
    }
  }

  createFormControl(ctrl) {
    if (Array.isArray(ctrl.controls)) {
      let innerFormGroup = {};
      let innerFormArray = [];
      ctrl.controls.forEach(innerCtrl => {
        innerFormGroup[innerCtrl.name] = this.createFormControl(innerCtrl);
      })
      if(ctrl.formType === 'FORM_ARRAY'){
        innerFormArray.push(new UntypedFormGroup(innerFormGroup));
        innerFormGroup = {};
        ctrl.validation.forEach(check=>{
          if(check === 'ZeroOrMoreLines'){
            return new UntypedFormArray([]);
          }
        })
        return new UntypedFormArray(innerFormArray);
      } else{
        return new UntypedFormGroup(innerFormGroup);
      }
    } else if (ctrl.groups) { //CP-8536

      let innerFormArray = [];
      let innerFormGroup = {};
      ctrl.groups.forEach(group => {
        let menuPages = JSON.parse(localStorage.getItem('menuPages'));
        if ((group.roleAccess && menuPages.includes(group.roleAccess)) || !group.roleAccess) {
          group.controls.forEach(control => {
            innerFormGroup[control.name] = this.createFormControl(control);
          });
        }
      });

      if (ctrl.formType === 'FORM_ARRAY') {
        innerFormArray.push(new UntypedFormGroup(innerFormGroup));
        innerFormGroup = {};
        ctrl.validation.forEach(check => {
          if (check === 'ZeroOrMoreLines') {
            return new UntypedFormArray([]);
          }
        })

        return new UntypedFormArray(innerFormArray);

      } else {
        return new UntypedFormGroup(innerFormGroup);
      }

    } else if (ctrl.tabs) { //CP-8536

      let groupForm = {};
      let groupArray = []
      ctrl.tabs.forEach((tab, i) => {
        groupArray[i] = this.createFormControl(tab);
        // groupForm[tab.name] = this.createFormControl(tab);
        // if (ctrl.formType === 'FORM_ARRAY') {
        //   groupArray.push(new FormGroup(groupForm));
        //   groupForm = {};
        // }
      });

      if (ctrl.formType === 'FORM_ARRAY') {
        return new UntypedFormArray(groupArray);
      }

      return new UntypedFormGroup(groupForm);
      
    } else {      
      let value = '';
      if (typeof ctrl.defaultValue === 'object') {
        value = this.fetchValueFromDefaultValue(ctrl)
        // defaultValue = Object.keys(ctrl.defaultValue); // to check if its not empty object
        // if (defaultValue.length) {
        //   if (ctrl.defaultValue['dataType']) {
        //     if (ctrl.defaultValue['dataType'].toLowerCase() === 'object') {
        //       value = ctrl.defaultValue;
        //     } else if (ctrl.defaultValue['dataType'].toLowerCase() === 'string') {
        //       value = ctrl.defaultValue['value'];
        //     } else {
        //       try {
        //         value = JSON.parse(ctrl.defaultValue['value']);
        //       } catch (e) {
        //         console.log('value is not in correct format:' + e);
        //         value = '';
        //       }
        //     }
        //   } else {
        //     value = ctrl.defaultValue;
        //   }
        // } else {
        //   value = '';
        // }
      }
      if (ctrl.required) {
        if(ctrl.component === 'DROPDOWN_SIMPLE_V2'){
          return new UntypedFormControl({value: value['value'] === '' ? value['value'] : value, disabled: ctrl.disabled}, [Validators.required, Validators.maxLength(parseInt(ctrl.maxLength))]);
        } else {
          return new UntypedFormControl({value: value, disabled: ctrl.disabled}, [Validators.required, Validators.maxLength(parseInt(ctrl.maxLength))]);
        }
      } else {
        if(ctrl.component === 'DROPDOWN_SIMPLE_V2'){
          return new UntypedFormControl({value: value['value'] === '' ? value['value'] : value, disabled: ctrl.disabled}, Validators.maxLength(parseInt(ctrl.maxLength)));
        } else {
          return new UntypedFormControl({value:value, disabled: ctrl.disabled}, Validators.maxLength(parseInt(ctrl.maxLength)));
        }
      }
    }
  }

  fetchValueFromDefaultValue(ctrl){
    let val = '';
    let defaultValue = Object.keys(ctrl.defaultValue); // to check if its not empty object
    if (defaultValue.length) {
      if (ctrl.defaultValue['dataType']) {
        if (ctrl.defaultValue['dataType'].toLowerCase() === 'object') {
          val = ctrl.defaultValue;
        } else if (ctrl.defaultValue['dataType'].toLowerCase() === 'string') {
          val = ctrl.defaultValue['value'];
        } else if (ctrl.defaultValue['dataType'].toLowerCase() === 'integer') {
          val = ctrl.defaultValue['value'];
        } else {
          try {
            val = JSON.parse(ctrl.defaultValue['value']);
          } catch (e) {
            console.log('value is not in correct format:' + e);
            val = '';
          }
        }
      } else {
        val = ctrl.defaultValue;
      }
    } else {
      val = '';
    }
    return val;
  }
  simpleFormatObject(data) {
    let finalObj = {};
    data.table.forEach(element => {
      let a = Object.keys(element);
      a.forEach(ele => {
        let b = element[ele][0];
        finalObj = { ...finalObj, ...b }
      })
    });
    console.log('Final print ', finalObj)
    return finalObj;
  }

  formatToParamsAndTables(orderData) {
    let orderPayload = { table: [], param: {} };
    for (let key in orderData) {
      if (Array.isArray(orderData[key]) && typeof orderData[key][0] == "object") {
        let obj = {}
        obj[key] = orderData[key];
        orderPayload.table.push(obj);
      } else {
        orderPayload.param[key] = orderData[key];
      }
    }
    return orderPayload;
  }

  formatToParamsAndTablesV2(data) {
    let obj = data.param;
    data.table.forEach(element => {
      obj = Object.assign(obj, element);
    });
    return obj;
  }

  expandFieldValues(tableEntry: { [key: string]: any[] }, expandField: string, expandSeparator: string): { [key: string]: any[] } {
    const key = Object.keys(tableEntry)[0];
    const expandedRows: any[] = [];

    (tableEntry[key] || []).forEach(row => {
      const values = (row[expandField] || '').split(expandSeparator).map((v: string) => v.trim()).filter((v: string) => v.length > 0);
      if (values.length <= 1) {
        expandedRows.push(row);
      } else {
        values.forEach((v: string) => expandedRows.push({ ...row, [expandField]: v }));
      }
    });

    return { [key]: expandedRows };
  }

  formatOrderObject(data) {
    let createOrderObject = {
      param: {},
      table: []
    };
    let obj = {};
    let groupObj = {};
    let parentObj = [];

    for (let control in data) {
      if (data[control].componentType === 'WRAPPER') {
        data[control].value.map(a => {
          Object.keys(a).forEach(b => {
            console.log(b, a[b]);
            if (a[b] == null || a[b] == undefined) {
              createOrderObject.param[b] = '';
            } else if (typeof a[b] == 'object') {
              if (a[b] instanceof Date) {
                if (a[b].toString() == 'Invalid Date')
                  createOrderObject.param[b] = '';
                else
                  createOrderObject.param[b] = this.getDateFormat(a[b]);
              } else {
                createOrderObject.param[b] = a[b].value;
              }
            } else {
              createOrderObject.param[b] = a[b];
            }
          })
        })
      }
      else if (data[control] instanceof UntypedFormControl) {
        if (data[control].value === null || data[control].value === undefined) {
          createOrderObject.param[control] = '';
        } else {
          if (typeof data[control].value == 'object' && data[control].value !== null) {
            if (data[control].value instanceof Date) {
              createOrderObject.param[control] = this.getDateFormat(data[control].value);
            }
            else if (data[control].value instanceof Array) {
              obj[control] = data[control].value;
              createOrderObject.table.push(obj);
              obj = {};
            }
            else {
              if(data[control].value.value || data[control].value.value === ''){
                createOrderObject.param[control] = data[control].value.value;
              } else{
                createOrderObject.param[control] = data[control].value;
              }
            }
          } else {
            createOrderObject.param[control] = data[control].value;
          }
        }
      } else if (data[control] instanceof UntypedFormArray) {
        // console.log(data[control].value);
        let limit = data[control].value.length;
        if(data[control] === data['shipments']){
          limit = data[control].controls.length;
        }

        for (let i = 0; i < limit; i++) {

          const rowControls: any = (data[control].controls[i] as any).controls;
          for (let k in rowControls) {
            if (rowControls[k].status === 'DISABLED') {
              let rawvalue = data[control].getRawValue();
              if (rawvalue[i][k] === null) {
                obj[k] = '';
              } else {
                if (typeof rawvalue[i][k] == 'object' && rawvalue[i][k] !== null){
                  obj[k] = rawvalue[i][k].value;
                  if (Array.isArray(rawvalue[i][k])) {
                    obj[k] = rawvalue[i][k];

                    //CP-8183 Accessorial codes are sending in the wrong format to OTM 
                    if (rowControls[k].controls){
                      obj[k] = this.formatIfValueIsObject(rowControls[k].getRawValue());
                    }
                    //CP-8183
                  }
                }
                else
                  obj[k] = rawvalue[i][k];
              }
            } else {
              if (rowControls[k].value === null) {
                obj[k] = '';
              } else {

                  if (typeof rowControls[k].value == 'object') {
                     // CP-4002 for save disabled fields
                     if (rowControls[k].controls){
                      obj[k] = this.formatIfValueIsObject(rowControls[k].getRawValue());
                    } else {
                      obj[k] = this.formatIfValueIsObject(rowControls[k].value);
                    }
                  }
                  else {
                    obj[k] = rowControls[k].value;
                  }
              }
            }
          }
          parentObj.push(obj);
          obj = {};
        }

        groupObj[control] = parentObj;
        const templateData = this.appService.getOrderTemplate();
        const tableCtrl = this.getControlFromJsonTemplate(templateData, control);
        if (tableCtrl?.expandEnabled && tableCtrl?.expandField && tableCtrl?.expandSeparator) {
          createOrderObject.table.push(
            this.expandFieldValues(groupObj, tableCtrl.expandField, tableCtrl.expandSeparator)
          );
        } else {
          createOrderObject.table.push(groupObj);
        }
        parentObj = [];
        groupObj = {};
      }
    }
    // createOrderObject.param['vendorId'] = localStorage.getItem('vendorId');

    //last check for wrapper


    return createOrderObject;
  }

  formatDynamicParamsV2(data, requestData) {
    let genrateParms = {};
    /***Object Generation ****/
    let menuDetails = JSON.parse(localStorage.getItem("menuPages"));
    let isGetRegistration = menuDetails.indexOf("REGISTRATION_LISTING") > -1;
    let customerCode = localStorage.getItem("customerCode");
    
    let userRoles = isGetRegistration
      ? JSON.parse(localStorage.getItem("customerList")).filter(
          (val) => val.customerCode == customerCode
        )
      : null;
    /**END***/
    for(var paramKey in data.request) {
      let typeOf = typeof data.request[paramKey];
      if(typeOf == 'object') {
        genrateParms[paramKey] = {};
        for (var objectParamKey in data.request[paramKey]) {
          let getObjKey = data?.request[paramKey][objectParamKey]?.replace("${", '')?.replace("}", '');
          if(!!requestData?.param[getObjKey] && requestData.param[getObjKey] != '') genrateParms[paramKey][objectParamKey] = requestData.param[getObjKey];
          if(getObjKey == "") genrateParms[paramKey][objectParamKey] = "";
          if(userRoles && getObjKey == "USER_ACCESS_ID") genrateParms[paramKey][objectParamKey] = userRoles[0]?.parameterValue;
        }
      } else {
        let getObjKey = data.request[paramKey].replace("${", '').replace("}", '');
        if(!!requestData?.param[getObjKey] && requestData?.param[getObjKey] != '') genrateParms[paramKey] = requestData.param[getObjKey];
        if(getObjKey == "") genrateParms[paramKey] = "";
        if(userRoles && getObjKey == "USER_ACCESS_ID") genrateParms[paramKey] = userRoles[0]?.parameterValue;
      }
    }
    if(requestData?.table?.length > 0) genrateParms["table"] = requestData?.table;
    return genrateParms;
  }

  private orderViewMetadata: {};
  setOrderViewMetadata(data) {
    this.orderViewMetadata = data;
  }
  getOrderViewMetadata() {
    return this.orderViewMetadata;
  }

  private form;
  setFormGroup(data) {
    let grp = {};
    data.controls.forEach((field) => {
      grp[field.name] = field.required === true ? new UntypedFormControl
        (Object.keys(field.defaultValue).length === 0 ? '' : field.defaultValue,
          [Validators.required, Validators.maxLength(parseInt(field['maxLength']))]) :
        new UntypedFormControl(Object.keys(field.defaultValue).length === 0 ? '' : field.defaultValue,
          Validators.maxLength(parseInt(field['maxLength'])));
    });
    let form = new UntypedFormGroup(grp);
  }
  getFormGroup() {
    return this.form;
  }

  createOrderFormToViewAndEdit(frmGroup, configData, obj) {
    for (let k in obj.value) {
      if (Array.isArray(obj.value[k]) && obj.value[k].length > 0) {
        let form = {};
        if (configData.sections) {
          configData.sections.forEach(sec => {
            let sectObj = {};
            if (obj.value[sec.name]) {
              sectObj["value"] = obj.value[sec.name][0];
              this.createOrderFormToViewAndEdit(frmGroup, sec, sectObj);
            }
          })
        }
        else {
          configData.groups.forEach(d => {
            d.controls.forEach(e => {
              if (e.name === k) {

                e.validation.forEach(f => {
                  if (f == "OneOrMoreLines") {
                    if (configData.component == "STEPPER") {
                      (<UntypedFormArray>frmGroup.get(configData.name)['controls'][0].get(k)).clear();
                    } else {
                      (<UntypedFormArray>frmGroup.get(k)).clear();
                    }
                    for (let i = 0; i < obj.value[k].length; i++) {

                      // e['controls'].forEach((field) => {
                      //   form[field.name] = field.required === true ? new FormControl
                      //     (Object.keys(field.defaultValue).length === 0 ? '' : field.defaultValue,
                      //       [Validators.required, Validators.maxLength(parseInt(field['maxLength']))]) :
                      //     new FormControl(Object.keys(field.defaultValue).length === 0 ? '' : field.defaultValue,
                      //       Validators.maxLength(parseInt(field['maxLength'])));
                      // });

                      e['controls'].forEach((field) => {
                        let value = this.fetchValueFromDefaultValue(field);
                        form[field.name] = 
                        field.required === true ? 
                        new UntypedFormControl({value: value['value'] === '' ? value['value'] : value, disabled: field.disabled}, [Validators.required, Validators.maxLength(parseInt(field['maxLength']))]) :
                        new UntypedFormControl({value: value['value'] === '' ? value['value'] : value, disabled: field.disabled}, Validators.maxLength(parseInt(field['maxLength'])));
                      });

                      if (configData.component == "STEPPER") {
                        (<UntypedFormArray>frmGroup.get(configData.name)['controls'][0].get(k)).push(new UntypedFormGroup(form));
                      } else {
                        (<UntypedFormArray>frmGroup.get(k)).push(new UntypedFormGroup(form));
                      }

                      form = {};
                    }
                    if (configData.component == "STEPPER") {
                      if (frmGroup.get(configData.name)['controls'][0].get(k).length > 1)
                        frmGroup.get(configData.name)['controls'][0].get(k)['controls']['deleteButton'] = true;
                      else {
                        frmGroup.get(configData.name)['controls'][0].get(k)['controls']['deleteButton'] = false;
                      }
                    } else {
                      if (frmGroup.get(k).length > 1)
                        frmGroup.get(k)['controls']['deleteButton'] = true;
                      else {
                        frmGroup.get(k)['controls']['deleteButton'] = false;
                      }
                    }
                  } else if (f == "ZeroOrMoreLines") {
                    for (let i = 0; i < obj.value[k].length; i++) {

                      e['controls'].forEach((field) => {
                        form[field.name] = field.required === true ? new UntypedFormControl
                          (Object.keys(field.defaultValue).length === 0 ? '' : field.defaultValue,
                            [Validators.required, Validators.maxLength(parseInt(field['maxLength']))]) :
                          new UntypedFormControl(Object.keys(field.defaultValue).length === 0 ? '' : field.defaultValue,
                            Validators.maxLength(parseInt(field['maxLength'])));
                      });
                      if (configData.component == "STEPPER") {
                        (<UntypedFormArray>frmGroup.get(configData.name)['controls'][0].get(k)).push(new UntypedFormGroup(form));
                      } else {
                        (<UntypedFormArray>frmGroup.get(k)).push(new UntypedFormGroup(form));
                      }

                      form = {};

                    }
                  }
                })
              }

              if (e.tabs && e.name === k) { //CP-9263
                e.tabs.forEach((t, i) => {
                  if (t.groups) {
                    let val = {}
                    val["value"] = obj.value[e.name][i];
                    if(configData.component === "STEPPER"){
                      this.createOrderFormToViewAndEdit(frmGroup.get(configData.name)['controls'][0].get(e.name)['controls'][i], t, val);
                    }
                    else{
                      this.createOrderFormToViewAndEdit(frmGroup.get(e.name)['controls'][i], t, val);
                    } 
                  }
                })
              }
            });
          })
        }
       
        if (configData['groups']) {
          configData.groups.forEach(d => {
            d.controls.forEach(e => {
              if (e.type == 'switch' && e.name === k && typeof obj.value[k] == 'boolean') {
                e.checked = obj.value[k];
              }
            })
          })
        }
      }
    }

    return frmGroup;
  }

  setSecondaryTextFormField(obj, frmGroup) {
    let menuPages = JSON.parse(localStorage.getItem("menuPages"));
    if (this.router?.url.includes('/carrier')) {
      let valueOf = obj?.value;
      let arrayOfValuesKey = Object.keys(obj?.value);
      arrayOfValuesKey.forEach(el => {
        if (el?.includes('secondory') && el?.includes('_')) {
          let dataX = el.split('_');
          if(frmGroup.get(dataX[0])) frmGroup.get(dataX[0])['secondaryText'] = valueOf[el];
        }
      });
      return;
    }
    let originMapUrl = "https://wego.here.com/directions/mix/" + obj.sourceLocationAddressLine + "," + obj.sourceLocationCity + ',' + obj.sourceLocationProvinceCode + ',' + obj.sourceLocationPostalCode + ',' + obj.sourceLocationCountryCode + '?map=' + obj.mapData.start.lat + ',' + obj.mapData.start.lng + ',15,normal';
    let destMapUrl = "https://wego.here.com/directions/mix/" + obj.destinationLocationAddressLine + "," + obj.destinationLocationCity + ',' + obj.destinationLocationProvinceCode + ',' + obj.destinationLocationPostalCode + ',' + obj.destinationLocationCountryCode + '?map=' + obj.mapData.finish.lat + ',' + obj.mapData.finish.lng + ',15,normal';

    let originLocationAddressToSearch = obj.sourceLocationAddressLine + "," + obj.sourceLocationCity + ',' + obj.sourceLocationProvinceCode + ',' + obj.sourceLocationPostalCode;
    let destLocationAddressToSearch = obj.destinationLocationAddressLine + "," + obj.destinationLocationCity + ',' + obj.destinationLocationProvinceCode + ',' + obj.destinationLocationPostalCode;
    let planFromLocationAddressToSearch = obj.planFromLocationAddressLine + "," + obj.planFromLocationCity + "," + obj.planFromLocationProvinceCode + "," + obj.planFromLocationPostalCode;
    let planToLocationAddressToSearch = obj.planToLocationAddressLine + "," + obj.planToLocationCity + "," + obj.planToLocationProvinceCode + "," + obj.planToLocationPostalCode;

    localStorage.setItem('originMapUrl', originMapUrl);
    localStorage.setItem('destMapUrl', destMapUrl);
    if (frmGroup.get('origin')) {
      frmGroup.get('origin')['secondaryText'] = originLocationAddressToSearch;
      frmGroup.get('origin')['itemArray'] = [obj.value.origin];
    }
    if (frmGroup.get('source')) {
      frmGroup.get('source')['secondaryText'] = originLocationAddressToSearch;
      frmGroup.get('source')['itemArray'] = [obj.value.source];
    }
    if (frmGroup.get('destination')) {
      frmGroup.get('destination')['secondaryText'] = destLocationAddressToSearch;

      frmGroup.get('destination')['itemArray'] = [obj.value.destination];
    }
    if (frmGroup.get('planFromLocation')) {
      frmGroup.get('planFromLocation')['secondaryText'] = planFromLocationAddressToSearch;
    }
    if (frmGroup.get('planToLocation')) {
      frmGroup.get('planToLocation')['secondaryText'] = planToLocationAddressToSearch;
    }


    let itemNameSecondaryText = '';

    if (obj.value.orderLines) {
      obj.value.orderLines.forEach((line, index) => {
        if (line.temp_control) {
          frmGroup.get('orderLines')['controls'][index]['tempControlIcon'] = true;
        } else if(frmGroup?.get('orderLines')?.['controls']?.[index]?.['tempControlIcon']) {
          frmGroup.get('orderLines')['controls'][index]['tempControlIcon'] = false;
        }
        if (line.hazmat) {
          frmGroup.get('orderLines')['controls'][index]['hazmatIcon'] = true;
        } else if(frmGroup?.get('orderLines')?.['controls']?.[index]?.['hazmatIcon']) {
          frmGroup.get('orderLines')['controls'][index]['hazmatIcon'] = false;
        }
        if (line.nmfcarticle !== '' || line.nmfcclass !== '') {
          if (line.nmfcarticle !== '') {
            itemNameSecondaryText = 'Article: ' + line.nmfcarticle;
          }
          if (line.nmfcclass !== '') {
            itemNameSecondaryText = itemNameSecondaryText + (line.nmfcarticle !== '' ? ', ' : '') + 'Class: ' + line.nmfcclass;
          }
        }
        if(frmGroup?.get('orderLines')?.['controls']?.[index]?.secondaryText) frmGroup.get('orderLines')['controls'][index].secondaryText = itemNameSecondaryText;
        if (frmGroup?.get('orderLines')?.['controls']?.[index]?.get('packagedItem')) {
          frmGroup.get('orderLines')['controls'][index].get('packagedItem')['itemArray'] = [line.packagedItem];
        }
      })
    }
    if (obj.value.poLines) {
      obj.value.poLines.forEach((line, index) => {
        let isDraftOrder = JSON.parse(localStorage.getItem("menuPages"));

        let shipFromId = line && line?.shipFromId  ? line.shipFromId : obj.value?.locationDetails?.origin?.locationId;
        let shipFromName = line && line?.shipFromName  ? line.shipFromName : obj.value?.locationDetails?.origin?.locationName;

        let shipToId = line && line?.shipToId ? line.shipToId : obj.value?.locationDetails?.destination?.locationId;
        let shipToName = line && line?.shipToName ? line.shipToName : obj.value?.locationDetails?.destination?.locationName;

        let poLineSecondaryText = {
          'source': '',
          'seperator': 'arrow_right_alt',
          'destination': ''
        };

        poLineSecondaryText.source = (shipFromId ||  shipFromName) ? shipFromId + ',' + shipFromName : null;
        poLineSecondaryText.destination = (shipToId || shipToName) ? shipToId + ',' + shipToName : null;

        frmGroup.get('poLines')['controls'][index].secondaryText = (poLineSecondaryText.source || poLineSecondaryText.destination)? poLineSecondaryText:""
        frmGroup.get('poLines')['controls'][index].get('poLineItem')['itemArray'] = [line.poLineItem];
      });
      localStorage.setItem('poSourceId', obj.value.poLines[0].shipFromId);
      localStorage.setItem('poDestId', obj.value.poLines[0].shipToId);
    }
  }
  setSecondaryStepperTextFormField(obj, frmGroup, secondaryCollection) {
    secondaryCollection.forEach(element => {
      Object.keys(frmGroup.value).forEach(step => {
        if (frmGroup.get(step)['controls'] && frmGroup.get(step)['controls'][0].get(element)) {
          let locationAddressToSearch = obj.value[step][0][element + "Line"] + "," + obj.value[step][0][element + "City"] + "," + obj.value[step][0][element + "ProvinceCode"] + "," + obj.value[step][0][element + "PostalCode"];
          //obj.sourceLocationAddressLine + "," + obj.sourceLocationCity + ',' + obj.sourceLocationProvinceCode + ',' + obj.sourceLocationPostalCode;
          frmGroup.get(step)['controls'][0].get(element)['secondaryText'] = locationAddressToSearch;
          frmGroup.get(step)['controls'][0].get(element)['itemArray'] = obj.value[step][0][element];
        }
      });
    });
    Object.keys(frmGroup.value).forEach(step => {
      if (frmGroup.get(step)['controls'] && frmGroup.get(step)['controls'][0].get('orderLines')) {
        let count = 0;
        frmGroup.get(step)['controls'][0].get('orderLines')['controls'].forEach(orderLine => {
          orderLine.get('packagedItem')['itemArray'] = obj.value[step][0]["orderLines"][count].packagedItem;
          count++;
        });
      }
    });
  }
  validateAllFormFields(formGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl && control.errors) {
        if (control.errors.required) {
          control.markAsTouched({ onlySelf: true });
          control.markAsDirty({ onlySelf: true });
        }
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      } else if (control instanceof UntypedFormArray) {
        control.controls.forEach(data => {
          this.validateAllFormFields(data);
        })
      }
    });
  }

  get fetchEvents() {
    return this._commonSubject.asObservable();
  }

  setEvent(event) {
    this._commonSubject.next(event);
  }

  getFormControl(formGroup: UntypedFormArray | UntypedFormGroup, formControlNames: string[]) {         //{1}
    let controlsArr = []
    if (Array.isArray(formGroup)) {
      for (let frmGrp of formGroup) {
        let dataArr = this.getFormControl(formGroup[frmGrp], formControlNames);
        controlsArr = controlsArr.concat(dataArr);
      }
      return controlsArr;
    } else {
      // }.forEach(field => {
      let controls = Object.keys(formGroup.controls)
      for (let ctrl of controls) {
        // let field = formGroup.controls[ctrl];                              //{2}
        const control = formGroup.get(ctrl);                    //{3}
        if (control instanceof UntypedFormControl) {
          if (formControlNames.indexOf(ctrl) != -1) {                        //{4}
            controlsArr.push({ name: ctrl, control: control });
          }
          // control.markAsTouched({ onlySelf: true });
        } else if (control instanceof UntypedFormGroup || control instanceof UntypedFormArray) {        //{5}
          let dataArr = this.getFormControl(control, formControlNames);            //{6}
          if (dataArr && dataArr.length) {
            controlsArr = controlsArr.concat(dataArr);
          }
        }
      }
      return controlsArr;
    }
  }

  formatIfValueIsObject(data) {
    if (typeof data === 'object' && data !== null) {
      if(data instanceof Array) {
        for (let k in data) {
          this.formatIfValueIsObject(data[k]);
        }
      } else {
        if (data.hasOwnProperty("value") && data) {
          data = data.value;
        } else {
          Object.keys(data).forEach(k => {
            if (data[k] instanceof Array) {
              for (let l in data) {
                this.formatIfValueIsObject(data[l]);
              }
            }
            else if (typeof data[k] === 'object') {
              if (data[k] && data[k].hasOwnProperty("value")) {
                data[k] = data[k].value; 
              }              
            }
          }, this);
        }
      }
    }

    return data;
  }

  //Validation n number of inputs/options relationship
  public groupValidationSrv = (configData, frmGroup) => {
    if (configData && !configData.groupValidation) return; //Check group validation is availble or not
    const arrayOfValidation = configData.groupValidation.columnGroup; //Convert object to array
    const singleArray = [].concat.apply([], arrayOfValidation); //concatenate of array
    const statusOfArray: any = [];// array of false only (False means fields are not fill)
    try {
      for (let a = 0; a < arrayOfValidation.length; a++) {
        let val: any = arrayOfValidation[a];
        //Check which groups are true/false
        let isRequeredGroup = val.map((data) => frmGroup.get(data).value).map(String).map(val => val.replace("null", '').length).includes(0);
        statusOfArray.push(isRequeredGroup); //Set False only
      };
    } finally {
      if (statusOfArray.indexOf(false) > -1) { //Check only not filled array only
        //Get first index of filled values
        let arrayOfOneIndex = statusOfArray.indexOf(false);
        arrayOfValidation[arrayOfOneIndex].forEach(fieldName => {
          frmGroup.get(fieldName)['isRequired'] = false; // this key is use for '*' mark show/hide
          frmGroup.get(fieldName).setValidators([Validators.required]);
          frmGroup.get(fieldName).updateValueAndValidity();
        });
        //Set remaing status for other input
        singleArray.forEach(fieldName => {
          if (!arrayOfValidation[arrayOfOneIndex].includes(fieldName)) {
            frmGroup.get(fieldName)['isRequired'] = true; // this key is use for '*' mark show/hide
            frmGroup.get(fieldName).clearValidators();
            frmGroup.get(fieldName).updateValueAndValidity();
          }
        })
      }
      else {
        //set required into all fields
        singleArray.forEach(fieldName => {
          frmGroup.get(fieldName)['isRequired'] = false;
          frmGroup.get(fieldName).setValidators([Validators.required]);
          frmGroup.get(fieldName).updateValueAndValidity();
        });
      }
    }
  }

  /**
  * Patches values into a FormGroup dynamically based on a given template and data values.
  * Iterates over the FormGroup controls and assigns values accordingly.
  *
  * @param frmGroup - The FormGroup to be patched.
  * @param template - The template structure used to determine form fields.
  * @param values - The data values to be patched into the form.
  */
  patchingValueForViewEdit(frmGroup: FormGroup, template: any, values: any) {
    Object.keys(frmGroup.controls).forEach(step => {
      if (!values[step]) return;
      const data = values[step];
      const parentForm = frmGroup.controls[step] as FormArray;
      if (!parentForm || !parentForm.controls.length) return;

      const formGroup = parentForm.controls[0] as FormGroup;
      Object.keys(formGroup.controls).forEach((key) => {
        const control = formGroup.get(key);

        if (['LineItem', 'shipCard'].includes(key) && control instanceof FormArray) {
          this.multiLineFormArray(control, template, key, data[key]);
        } else if (control) {
          control.patchValue(data[key]);
          this.handleValidationOnReset(template, key, data, '');
        }
      });
    });
  }

  /**
  * Dynamically populates a FormArray with multiple Line Items or Ship Units.
  * Clears the existing FormArray and repopulates it with new controls based on data.
  *
  * @param control - The FormArray to be updated.
  * @param template - The template structure used to generate new form controls.
  * @param key - The field name (LineItem or shipCard).
  * @param data - The array of values to be added to the FormArray.
  */
  private multiLineFormArray(control: FormArray, template: any, key: string, data: any[]) {
    control.clear();
    data.forEach((_, index) => {
      let targetControl = this.findControlFromTemplate(template, key, control);
      let newForm = this.createFormControl(targetControl);

      if (newForm instanceof FormArray && newForm.controls.length > 0) {
        newForm = newForm.controls[0] as FormGroup;
      }

      if (newForm instanceof FormGroup) {
        control.push(newForm);
        this.patchNestedFormArray(newForm, key, data, index);
      } else {
        console.error(`ERROR: newForm is not a FormGroup!`, newForm);
      }
    });
  }

  /**
 * Handles the nested FormArray inside an Accordion Component.
 * Patches values into the nested structure dynamically.
 *
 * @param group - The parent FormGroup containing the accordion component.
 * @param key - The field name.
 * @param data - The array of values to be patched.
 * @param index - The index of the current item in the array.
 */
  private patchNestedFormArray(group: FormGroup, key: string, data: any[], index: number) {
    const accordianComponent = group.get('accordianComponent') as FormArray;
    if (!accordianComponent || !(accordianComponent instanceof FormArray)) return;

    accordianComponent.controls.forEach((formGroupControl: AbstractControl) => {
      if (formGroupControl instanceof FormGroup) {
        Object.keys(formGroupControl.controls).forEach((field) => {
          const fieldControl = formGroupControl.get(field);
          if (fieldControl instanceof FormArray && fieldControl.controls.length > 0) {
            fieldControl.controls[0].patchValue(data[index]);
          }
        });
      }
    });
  }

  /**
 * Recursively finds a control from the template structure based on a field name.
 *
 * @param template - The template structure.
 * @param fieldName - The field name to locate in the template.
 * @param targetForm - The target FormGroup or FormArray.
 * @returns The matching control from the template, if found.
 */
  findControlFromTemplate(template: any, fieldName: string, targetForm: any): any {
    if (!template) return null;

    if (template.sections?.length) {
      for (const section of template.sections) {
        const result = this.findControlFromTemplate(section, fieldName, targetForm);
        if (result) return result;
      }
    }

    if (template.groups?.length) {
      for (const group of template.groups) {
        const result = this.findControlFromTemplate(group, fieldName, targetForm);
        if (result) return result;
      }
    }

    if (template.controls?.length) {
      if (template.component === 'TABLE_V2' && template.validation?.includes('OneOrMoreLines') && template.name === fieldName) {
        return template;
      }

      for (const control of template.controls) {
        const result = this.findControlFromTemplate(control, fieldName, targetForm);
        if (result) return result;
      }
    }
    if (template.label === fieldName) {
      return template;
    }
    return null;
  }

  /**
  * Formats dynamic accordion data into a structured output format.
  *
  * @param input - The raw input data containing table structures.
  * @returns A formatted object with processed step data.
  */
  formatDynamicAccordion(input) {
    let output = {};
    input.table.forEach(step => {
      let stepKey = Object.keys(step)[0];
      let stepValue = step[stepKey];

      if (Array.isArray(stepValue)) {
        output[stepKey] = {};

        stepValue.forEach((item) => {
          const transformed = this.transformStep(item);
          output[stepKey] = transformed;
        });
      }
    });

    return output;
  }

  /**
 * Transforms each step in the data structure to ensure proper formatting.
 *
 * @param obj - The step object to transform.
 * @returns The transformed step object.
 */
  transformStep(obj) {
    if (typeof obj !== 'object' || obj === null) {
      return obj;
    }

    let newObj = {};
    Object.keys(obj).forEach(key => {
      if (Array.isArray(obj[key])) {
        newObj[key] = obj[key].map(subItem => this.transformStep(subItem));
      } else {
        newObj[key] = obj[key];
      }
    });

    return this.processStepDetails(newObj);
  }

  /**
 * Processes step details, merging nested properties where needed.
 *
 * @param obj - The object containing step data.
 * @returns A processed object with structured data.
 */
  processStepDetails(obj: any): any {
    const hasLineItems = Array.isArray(obj.LineItem);
    const hasShipCards = Array.isArray(obj.shipCard);

    if (!hasLineItems && !hasShipCards) {
      return { ...obj };
    }

    const newLineItems: any[] = [];
    const newShipCards: any[] = [];
    const mainObj: Record<string, any> = {};

    if (hasLineItems) {
      obj.LineItem.forEach(lineItem => {
        lineItem.accordianComponent?.forEach((component: any) => {
          newLineItems.push(this.mergeNestedProperties(component));
        });
      });
    }

    if (hasShipCards) {
      obj.shipCard.forEach((ship: any) => {
        ship.accordianComponent?.forEach((component: any) => {
          newShipCards.push(this.mergeNestedProperties(component));
        });
      });
    }

    // Copy only string (non-array) values except lineItem and shipCard
    for (const [key, value] of Object.entries(obj)) {
      if (key !== "LineItem" && key !== "shipCard" && typeof value === "string" && !Array.isArray(value)) {
        mainObj[key] = value;
      }
    }

    mainObj.LineItem = newLineItems;
    mainObj.shipCard = newShipCards;

    return mainObj;
  }

  /**
  * Merges nested properties from a component by extracting and flattening its object values.
  *
  * @param component - The component object containing nested properties.
  * @returns A merged object with flattened properties.
  */
  mergeNestedProperties(component) {
    return Object.keys(component).reduce((acc, key) => {
      if (Array.isArray(component[key]) && component[key].length > 0 && typeof component[key][0] === "object") {
        return Object.assign(acc, component[key][0]); // Merge first object inside array
      }
      return acc;
    }, {});
  }

  /**
  * Recursively validates an GSKRD form control with Accordion and its nested child controls.
  *
  * Traverses through the form hierarchy (FormGroup, FormArray, and FormControl) and
  * collects paths of fields that have values filled and those that are invalid.
  *
  * @param control - AbstractControl instance to validate. Can be FormGroup, FormArray, or FormControl.
  * @param path - An array of strings representing the current traversal path to the control. Used internally during recursion.
  * @param values - The values object corresponding to the control's value structure. Used to determine if a field is filled.
  * @param filledFields - An array to collect dot-separated string paths of fields that have non-empty values.
  * @param invalidFields - An array to collect dot-separated string paths of fields that are invalid.
  *
  * @returns An object containing:
  *  - filledFields: string[] — Paths of fields with values filled.
  *  - invalidFields: string[] — Paths of fields that are invalid.
  *  - totalErrors: number — Total count of invalid fields found.
  */
   validateDraftOrderFormRecursively(enableDraftSaveWithErrorsArray: string[]=[] ,control: AbstractControl, path: string[] = [], values: any = {}, filledFields: string[] = [], invalidFields: string[] = []) {
    if (control instanceof FormGroup) {
      Object.keys(control.controls).forEach(key => {
        this.validateDraftOrderFormRecursively(
          enableDraftSaveWithErrorsArray,
          control.controls[key],
          [...path, key],
          values?.[key] ? values?.[key] : values,
          filledFields,
          invalidFields
        );
      });
    } else if (control instanceof FormArray) {
      control.controls.forEach((ctrl, index) => {
        this.validateDraftOrderFormRecursively(
          enableDraftSaveWithErrorsArray,
          ctrl,
          [...path, `[${index}]`],
          Array.isArray(values) ? values[index] : values,
          filledFields,
          invalidFields
        );
      });
    } else if (control instanceof FormControl) {
      const value = values;
      const fullPath = path.join('.');
      if (value !== null && value !== undefined && value !== '' && typeof value !== 'object') {
        filledFields.push(fullPath);
        if (enableDraftSaveWithErrorsArray?.length > 0) {
          if (control.invalid && !enableDraftSaveWithErrorsArray.includes(path[path.length - 1])) {
            invalidFields.push(fullPath);
          }
        }
      }
      }

    return { filledFields, invalidFields, totalErrors: invalidFields.length };
  }

  /**
 * Handles validation logic and resets specific UI behavior for a form field based on its component type.
 * 
 * This function is typically called when the form is reset, and it reinitializes field values,
 * validations, and UI states based on configuration from a dynamic template.
 * 
 * Supported component types:
 * - `GENERIC_AUTOCOMPLETE_V2`: Pushes the field value to `itemArray` and re-selects it.
 * - `GENERIC_FIELD_V2`: Triggers `onFormReset` if `populateFrom` is defined in validation config.
 * - `DROPDOWN_SIMPLE_V2`: Resets the selected option if validations or affected column keys are triggered.
 * 
 * @param {Object} template - The JSON template that defines form field configurations.
 * @param {string} fieldName - The name (key) of the field to reset and validate.
 * @param {Object} data - The current data object containing field values, typically from form state.
 * 
 * @returns {void}
 * 
 * @example
 * handleValidationOnReset(formTemplate, 'country', { country: 'India' });
 */
  handleValidationOnReset(template, key, data, control?: any) {
    const fieldControl = control || this.getControlFromJsonTemplate(template, key);
    if (!fieldControl) return;

    const validatedEvents = fieldControl?.events?.some(e =>
      APP_Constants?.VALIDATION_EVENTS?.includes(e.event)
    );

    const validateAffectedColumnEvents = APP_Constants?.AFFECTED_COLUMN_KEYS?.some(key =>
      (fieldControl?.[key] || []).some((item: any) =>
        Array.isArray(item?.value) && item.value.length > 0
      )
    );

    const fieldName = fieldControl["name"];
    const componentRef = this.appService._components[fieldName];
    const value = data?.[fieldName];

    switch (fieldControl?.component) {
      case "GENERIC_AUTOCOMPLETE_V2":
        if (validatedEvents && componentRef) {
          componentRef.frmGroup?.get(fieldName)?.['itemArray']?.push(value);
          componentRef.selectItem?.(null, { primaryText: value, primaryValue: value }, false, true);
        }
        break;

      case "DROPDOWN_SIMPLE_V2":
        if (componentRef) {
          const selectedOption = fieldControl.options?.find(opt =>
            opt?.value?.toUpperCase() === value?.toUpperCase()
          );
          if (validatedEvents || validateAffectedColumnEvents) {
            componentRef.selectedOption?.(selectedOption, null, true);
          }
        }
        break;

      case "CHIPSAUTOCOMPLETE":
        if ((validatedEvents || validateAffectedColumnEvents) && componentRef) {
          componentRef.setDefaultValueOnReset?.();
        }
        break;

      case "GENERIC_FIELD_V2":
        if (fieldControl?.validationV2?.populateFrom && componentRef) {
          componentRef.setDefaultValueOnReset?.();
        }
        break;
    }
  }

  /**
  * Recursively searches through a dynamic JSON-based UI template to find a control
  * by its `name` property.
  *
  * The search is performed in the following hierarchy:
  * - The current template node itself
  * - Sections (if present)
  * - Groups (if present)
  * - Controls (if present)
  *
  * This function is typically used in form rendering engines or dynamic form builders
  * where UI components are generated from a JSON configuration.
  *
  * @param {object} template - The JSON template node to search in.
  * @param {string} controlName - The `name` of the control to find.
  * @returns {object|null} - The control object if found, otherwise `null`.
  *
  */
  getControlFromJsonTemplate(template, controlName) {
    if (!template) return null;

    if (template.name === controlName) {
      return template;
    }

    if (Array.isArray(template.sections)) {
      for (const section of template.sections) {
        const found = this.getControlFromJsonTemplate(section, controlName);
        if (found) return found;
      }
    }

    if (Array.isArray(template.groups)) {
      for (const group of template.groups) {
        const found = this.getControlFromJsonTemplate(group, controlName);
        if (found) return found;
      }
    }

    if (Array.isArray(template.controls)) {
      for (const control of template.controls) {
        const found = this.getControlFromJsonTemplate(control, controlName);
        if (found) return found;
      }
    }

    return null;
  }

  /**
 * Recursively extracts all control `name` values from a deeply nested form configuration object.
 *
 * This function is useful when working with dynamic form rendering systems,
 * where controls are defined in a JSON-like structure with nested `controls` arrays
 * (e.g., inside tables, accordions, form sections, etc.).
 *
 * @param config - The root configuration object or array representing form controls.
 *                 Each control may contain a `name`, `component`, and optionally nested `controls`.
 * @param collected - (Optional) An array to collect the extracted control names.
 *                    Used internally during recursion. Defaults to an empty array.
 *
 * @returns An array of all control `name` strings found in the provided config.
 *
 * @example
 * const controlNames = extractFieldNamesFromConfig(formConfig);
 * // Output: ['materialType', 'casNumber', 'solventConc', ...]
 */
  extractFieldNamesFromConfig(config: any, collected: string[] = []): string[] {
    if (!config) return collected;

    if (Array.isArray(config)) {
      config.forEach(child => this.extractFieldNamesFromConfig(child, collected));
    } else if (typeof config === 'object') {
      if (config.name) {
        collected.push(config);
      }
      if (config.controls) {
        this.extractFieldNamesFromConfig(config.controls, collected);
      }
    }
    return collected;
  }

  // handleAPIResponse(response){
  //   if (response['message'].statusCode == APP_Constants.SUCCESS_CODE) {
  //     this.formError = ''
  //     let times = 0;
  //     let transmissionStatus;
  //     setTimeout(() => {

  //       this.appService.makeHttpGetRequest(APP_Constants.CREATE_ORDER_TRANSMISSION_STATUS + localStorage.getItem('customerCode') + '&orderId=' +
  //         response['orderId'] + '&transmissionNo=' + response['transmissionNo'] + '&userId=' + localStorage.getItem('userName'),
  //             ).subscribe(
  //               data => {
  //                 console.log(data);
  //                 transmissionStatus = data;
  //                 if(transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE ||
  //                 transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.FAILED_CODE ){
  //                     this.isLoading = false;
  //                     this.normalView();
  //                     this._snackBar.openFromComponent(SnackBarComponent, { duration: this.durationInSeconds * 1000, data: { orderId: transmissionStatus['orderId'], message: transmissionStatus['message'].statusMessage } });
  //                     this.router.navigateByUrl('/orders');
  //                 }

  //               }, err => {
  //                 this.isLoading = false;
  //                 this.normalView();

  //                 let modal = new Modal({
  //                   action: false, name: 'orderStatus', title: 'Order status', description: err.message, actionButtonText: ''
  //                 });
  //                 this.modalService.createModalBox(modal, err.status);
  //                 console.log(err);
  //               });

  //       let intervalId = setInterval(() => {
  //         if (
  //           transmissionStatus &&
  //           (
  //             transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE ||
  //             transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.FAILED_CODE
  //           )) {
  //           this.isLoading = false;
  //           this.normalView();
  //           clearInterval(intervalId);
  //         } else if(++times == 5  && transmissionStatus &&  transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.IN_PROGRESS_CODE ){
  //           this.isLoading = false;
  //           this.normalView();
  //           this._snackBar.openFromComponent(SnackBarComponent, {duration: this.durationInSeconds * 1000, data: { orderId: transmissionStatus['orderId'], message: transmissionStatus['message'].statusMessage} });
  //           this.router.navigateByUrl('/orders');
  //           clearInterval(intervalId);
  //         } else {
  //           this.appService.makeHttpGetRequest(APP_Constants.CREATE_ORDER_TRANSMISSION_STATUS + localStorage.getItem('customerCode') + '&orderId=' +
  //             data['orderId'] + '&transmissionNo=' + data['transmissionNo'] + '&userId=' + localStorage.getItem('userName'),
  //             ).subscribe(
  //               data => {
  //                 console.log(data);
  //                 transmissionStatus = data;
  //                 if(transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.SUCCESS_CODE ||
  //                 transmissionStatus['message'].statusCode.toUpperCase() === APP_Constants.FAILED_CODE ){
  //                   this.isLoading = false;
  //                   this.normalView();
  //                   this._snackBar.openFromComponent(SnackBarComponent, { duration: this.durationInSeconds * 1000, data: { orderId: transmissionStatus['orderId'], message: transmissionStatus['message'].statusMessage } });
  //                   this.router.navigateByUrl('/orders');
  //                 }
  //               }, err => {
  //                 this.isLoading = false;
  //                 this.normalView();

  //                 let modal = new Modal({
  //                   action: false, name: 'orderStatus', title: 'Order status', description: err.message, actionButtonText: ''
  //                 });
  //                 this.modalService.createModalBox(modal, err.status);
  //                 console.log(err);
  //               });
  //         }
  //       }, 3000);
  //     }, 1000);
  //   }
  // }

}
